import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MY_DATE_FORMATS } from './core/dateFormatConfig';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DotDateAdapter } from './core/dotDateAdapter';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    BrowserAnimationsModule,
    BrowserModule,
    importProvidersFrom([GoogleMapsModule]),
    provideNativeDateAdapter(),
    provideHttpClient(withFetch()),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: DotDateAdapter },
  ],
};
